import Icon from 'veui/components/Icon'
import { IconBooksBookmark } from 'dls-icons-vue'

Icon.register('books-bookmark', IconBooksBookmark)
